var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.srcList && _vm.srcList.length > 0)?_c('el-image',{style:({
    width: _vm.size,
    height: _vm.size,
    'border-radius': '5px',
    border: '1px solid var(--fm-border-color)',
  }),attrs:{"fit":"cover","preview-src-list":_vm.srcList,"src":_vm.srcList[0]}}):(_vm.emptyShow)?_c('el-image',{style:({
    width: _vm.size,
    height: _vm.size,
    'border-radius': '5px',
    border: '1px solid var(--fm-border-color)',
  }),attrs:{"fit":"cover","src":require('@/assets/logo.png')}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6ceb3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm/CommodityImage.vue
// module id = null
// module chunks = 